import React from 'react';
import { Tabs } from 'antd';
import Layout from '../../../components/Layout';
import SmsProvider from './SmsProvider';
import BillsProvider from './BillsProvider';

const { TabPane } = Tabs;

const Vendors = () => {
  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <h2 style={{ marginBottom: '20px' }}>Vendors Configuration</h2>
        <div style={{ background: '#fff', padding: '24px', borderRadius: '8px' }}>
          <Tabs defaultActiveKey="1">
            <TabPane tab="SMS Provider" key="1">
              <SmsProvider />
            </TabPane>
            <TabPane tab="Bills Routing" key="2">
              <BillsProvider />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </Layout>
  );
};

export default Vendors;
